import React from 'react'
import { RichTextRenderer } from '../common/RichTextRenderer'

const WhatWillYouLearn = ({ whatYouWillLearn = '' }) => (
  <section>
    <div className="flex flex-wrap heading-top-space">
      <h1 className="tagline-font text-white tracking-wide md:text-2xl text-xl  mb-2.5">
        WHAT YOU WILL LEARN
      </h1>
      <span className="text-sm tracking-wider pr-7 mt-4">
        <RichTextRenderer richTextDocument={whatYouWillLearn} />
      </span>
    </div>
  </section>
)

export default WhatWillYouLearn
